import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { SelectRoleField } from 'modules/components/layer04';


export type SaveMembershipFormProps = {
  personId: string;
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: SaveMembershipFormProps) => {
  const [
    fnSaveMembershipForm,
    { loading }
  ] = ds.useSaveMembership();
  const form = ds.useFormState(props.personId, props.projectId);
  const handleSubmit = async (data: ds.IFormState) => {
    const input = {
      ...data
    };
    await fnSaveMembershipForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <SelectRoleField.FC
        form={form}
        isMultiple={true}
        fieldName='roles'
      />
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
